import { render, staticRenderFns } from "./MaterialTagManagement.vue?vue&type=template&id=fe9b022c&scoped=true"
import script from "./MaterialTagManagement.vue?vue&type=script&lang=js"
export * from "./MaterialTagManagement.vue?vue&type=script&lang=js"
import style0 from "./MaterialTagManagement.vue?vue&type=style&index=0&id=fe9b022c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9b022c",
  null
  
)

export default component.exports